import { GET_ALL_MISMATCH_REQUESTS } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';
import { IRaiseMismatch } from './getMismatchRequests';

const getAllMismatchRequestsQueryKey = ['all-mismatch-requests'];

const getAllMismatchRequests = async (): Promise<{
  success: boolean;
  data?: IRaiseMismatch[];
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(GET_ALL_MISMATCH_REQUESTS);

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export {
  getAllMismatchRequests,
  type IRaiseMismatch,
  getAllMismatchRequestsQueryKey,
};
